import script from "./mini-pay-middle.vue?vue&type=script&lang=ts&setup=true"
export * from "./mini-pay-middle.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__